import React from 'react';
import styled from 'styled-components';
import Tile from './Tile';

const PlayerHand = ({ tiles, onTileClick, selectableTiles = [], selectedTile = null }) => {
  return (
    <HandContainer>
      <HandTitle>내 패</HandTitle>
      <TilesContainer>
        {tiles.map((tile, index) => (
          <Tile 
            key={tile.id || index}
            tile={tile}
            onClick={() => onTileClick(tile, index)}
            isSelectable={selectableTiles.includes(tile.id)}
            isSelected={selectedTile && selectedTile.id === tile.id}
          />
        ))}
      </TilesContainer>
    </HandContainer>
  );
};

const HandContainer = styled.div`
  width: 100%;
  padding: 10px;
  background-color: #143d28;
  border-radius: 8px 8px 0 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
`;

const HandTitle = styled.h3`
  color: #f8cb66;
  margin: 0 0 10px 0;
  font-size: 1rem;
  text-align: center;
`;

const TilesContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  overflow-x: auto;
  padding-bottom: 5px;
  
  /* 스크롤바 스타일링 */
  &::-webkit-scrollbar {
    height: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: #0a2918;
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #f8cb66;
    border-radius: 2px;
  }
`;

export default PlayerHand;
